/** Category tile IDs rendered on the DE homepage (all SliderCategories + SliderSpecials). */
export const HOME_DE_SLIDER_CATEGORY_IDS = [
  1157, 1159,
  1160, 18522, 24150, 1161,
  21905, 26783, 26714, 26803,
  1284, 23633, 1362, 1382,
  26537, 1163
] as const

/** Category tile IDs on the AT homepage. */
export const HOME_AT_SLIDER_CATEGORY_IDS = [
  23314, 19217,
  27871, 22070, 23320, 26415
] as const

export function getHomeSliderCategoryIds (storeCode: string): number[] {
  if (storeCode === 'zaun24_at') {
    return [...HOME_AT_SLIDER_CATEGORY_IDS]
  }
  return [...HOME_DE_SLIDER_CATEGORY_IDS]
}
